import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'

import { motion, AnimatePresence } from 'framer-motion'

import * as styles from './mobileNav.module.scss'
import xealWhite from 'src/images/logos/xealWhite.svg'
import xealDark from 'src/images/logos/XealLogoDark.svg'

import hamburger from 'src/images/icons/Hamburger.svg'
import hamburgerDark from 'src/images/icons/Hamburger-dark.svg'
import close from 'src/images/icons/modalCloseIcon.svg'

import headerLinks from '../../globals/headerLinks'

export default function MobileNav({ mobileTheme }) {
  const [open, setNavOpen] = useState(false)

  const handleToggle = () => {
    if (open) {
      setNavOpen(false)
      if (typeof window !== `undefined`) {
        document.querySelector('body').style.overflow = ''
      }
    } else {
      setNavOpen(true)
      if (typeof window !== `undefined`) {
        document.querySelector('body').style.overflow = 'hidden'
      }
    }
  }

  useEffect(
    () => () => {
      if (typeof window !== `undefined`) {
        document.querySelector('body').style.overflow = ''
      }
    },
    []
  )

  return (
    <>
      <motion.div
        className={classNames(styles.mobileNav, {
          [styles.navOpen]: open,
          [styles.mobileThemeLight]: mobileTheme === 'light',
        })}
      >
        <Link to="/">
          <picture>
            {!open && (
              <>
                <source
                  srcSet={mobileTheme === 'light' ? xealDark : xealWhite}
                  media="(max-width:1024px)"
                  width="80"
                  height="36"
                />
                {/* <source srcSet={xealDark} /> */}
              </>
            )}

            {open && (
              <source
                srcSet={xealDark}
                media="(max-width:1024px)"
                width="80"
                height="36"
              />
            )}

            <img src={xealWhite} alt="Xeal" width="80" height="36" />
          </picture>
        </Link>
        <button onClick={handleToggle}>
          <picture>
            {!open && (
              <>
                <source
                  srcSet={mobileTheme === 'light' ? hamburgerDark : hamburger}
                  width="28"
                  height="13"
                />
              </>
            )}

            {open && <source srcSet={close} width="25" height="25" />}

            <img src={hamburger} alt="mobile nav open" width="28" height="13" />
          </picture>
        </button>
      </motion.div>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <MobileDropdownNav />
            <div className={styles.mobileDropdownNavBackground} />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

const MobileDropdownNav = () => {
  return (
    <nav className={styles.mobileDropdownNav}>
      <ul className={styles.navLinks}>
        {headerLinks.nav.map(({ text, to, nav }) =>
          nav ? (
            <li key={text} className={styles.navDropdownWrap}>
              <span className={styles.navHeader}>{text}</span>
              <ul>
                {nav.map(({ text, to }) => (
                  <li key={text}>
                    <Link to={to} activeClassName={styles.active}>
                      {text}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ) : (
            <li key={text}>
              <Link
                to={to}
                activeClassName={styles.active}
                className={styles.navLink}
              >
                {text}
                {text === 'Technology' && (
                  <span className={styles.patented}>PATENTED</span>
                )}
              </Link>
            </li>
          )
        )}
      </ul>

      <div className={styles.logins}>
        <a
          href={headerLinks.logins.buildingManager.href}
          target="_blank"
          rel="noreferrer"
        >
          {headerLinks.logins.buildingManager.text}
        </a>
        <a
          href={headerLinks.logins.partner.href}
          target="_blank"
          rel="noreferrer"
        >
          {headerLinks.logins.partner.text}
        </a>
      </div>

      <div className={styles.talkWrap}>
        <p className="body-1">Talk to a specialist</p>
        <a href="tel:(800) 484-4515">(800) 484-4515</a>
      </div>
    </nav>
  )
}
